import script from "./ModalOne.vue?vue&type=script&setup=true&lang=ts"
export * from "./ModalOne.vue?vue&type=script&setup=true&lang=ts"

import "./ModalOne.vue?vue&type=style&index=0&id=16ad0654&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-16ad0654"]])

export default __exports__